import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiEndpointWrapper } from '../types/interfaces/endpoints';
import { ApiEndpoint } from '../types/interfaces/api-endpoint';

@Injectable({
  providedIn: 'root',
})
export class EndpointsMaintenanceService {
  private baseUrl = `${environment.apiHost}/maintenance/endpoints`;

  constructor(private http: HttpClient) {}

  public getEndpoints(): Observable<ApiEndpointWrapper[]> {
    return this.http.get<ApiEndpointWrapper[]>(this.baseUrl, {
      withCredentials: true,
    });
  }

  public addEndpoint(
    endpoint: ApiEndpointWrapper
  ): Observable<ApiEndpointWrapper> {
    return this.http.post<ApiEndpointWrapper>(this.baseUrl, endpoint, {
      withCredentials: true,
    });
  }

  public updateEndpoint(
    endpoint: ApiEndpointWrapper
  ): Observable<ApiEndpointWrapper> {
    return this.http.put<ApiEndpointWrapper>(
      this.baseUrl + `/${endpoint.id}`,
      endpoint,
      {
        withCredentials: true,
      }
    );
  }

  public deleteEndpoint(endpointId: number): Observable<ApiEndpoint> {
    return this.http.delete<ApiEndpoint>(this.baseUrl + `/${endpointId}`, {
      withCredentials: true,
    });
  }
}
